import { useEffect } from "react";
import Auth from "../../Auth";
import firebase from "../../Firebase.js";
import Cookies from "universal-cookie";
import { AUTHOR_NATION } from "../../../../src/shared/conferenceCampaign";

const MAX_AGE_SECONDS = 43200; // 12 hours in seconds

export default function Logout({}) {
  useEffect(() => {
    Auth.markLogoutInProgress();
    // Check if previous page was a shared link page
    const isSharedLinkPage = /\/app\/documents\/[^/]+\/feedback/.test(document.referrer);
    const conference = new URLSearchParams(window.location.search).get("campaign") === AUTHOR_NATION.id;
    const returnUrl = conference ? AUTHOR_NATION.path : isSharedLinkPage ? document.referrer : null;
    // detect logged out state then redirect to home
    firebase.auth().onAuthStateChanged(async (userAuth) => {
      // set cookie at logout for bug where user cannot login immediately after logout
      const cookies = new Cookies();
      cookies.set("recent_logout", true, {
        maxAge: MAX_AGE_SECONDS, // 12 hours
        path: "/",
        expires: new Date(Date.now() + MAX_AGE_SECONDS * 1000), // using milliseconds to set expiration
      });

      if (!userAuth) {
        if (returnUrl) {
          window.location.href = returnUrl;
        } else {
          // redirect to marketing site hosted at www.sudowrite.com
          // do we need a different value for development so we don't go off localhost?
          window.location.href = process.env.REACT_APP_MARKETING_PAGE_URL;
        }
      }

      localStorage.removeItem("all-folders-store");
      localStorage.removeItem("sticky-tour-store");
    });

    firebase.auth().signOut();
  }, []);

  return null;
}
